import '@assets/app.scss';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from '@app/router/router';
import routes from '@app/routes';
import { ApolloProvider } from '@apollo/client';
import client from '@app/api/apollo/client';
import ErrorBoundary from '@app/components/ErrorBoundary';
import * as AuthContext from '@app/hooks/useAuthContext';
import * as UseFetch from 'use-http';
import { SentryRoutes } from '@app/sentry';

export default function App() {
  return (
    <UseFetch.Provider url={AppConfig.API_HOST} options={{
      credentials: 'include',
    }}>
      <ApolloProvider client={client}>
        <AuthContext.Provider>
          <BrowserRouter>
            <ErrorBoundary>
              <SentryRoutes>
                {renderRoutes(routes)}
              </SentryRoutes>
            </ErrorBoundary>
          </BrowserRouter>
        </AuthContext.Provider>
      </ApolloProvider>
    </UseFetch.Provider>
  );
}
